/* eslint-disable no-console */
import {Table} from 'antd';
import React from 'react';

import {formatIndian} from '../../../utils/formatIndian';
import {B2bKey, B2bLabel} from '../../Forms/Constants/Products/B2BKeyLabel';

const B2bDis: React.FC<{dataSource: any; suppliers: any}> = ({
  dataSource,
  suppliers
}) => {
  const columns: any = [
    {
      title: B2bLabel.SUPPLIER_ID,
      dataIndex: B2bKey.SUPPLIER_ID,
      width: 120,
      render: (value: any) => {
        return (
          <>
            {
              suppliers.find((item: any) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: B2bLabel.FUEL_EMISSION,
      dataIndex: B2bKey.FUEL_EMISSION,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    },
    {
      title: B2bLabel.ELEC_EMISSION,
      dataIndex: B2bKey.ELEC_EMISSION,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    },
    {
      title: B2bLabel.WASTE_EMISSION,
      dataIndex: B2bKey.WASTE_EMISSION,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    }
  ];

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={dataSource}
      pagination={{pageSize: 50}}
      scroll={{y: 240}}
      rowKey={B2bKey.SUPPLIER_ID}
      // tableLayout="auto"
    />
  );
};

export default B2bDis;
